import { useState } from "react";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { StatsStrip } from "@/components/landing/StatsStrip";
import { WhatWeDo } from "@/components/landing/WhatWeDo";
import { Why } from "@/components/landing/Why";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { SocialImpact } from "@/components/landing/SocialImpact";
import { Pricing } from "@/components/landing/Pricing";
import { About } from "@/components/landing/About";
import { Faq } from "@/components/landing/Faq";
import { BookingForm } from "@/components/landing/BookingForm";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  const [selectedPackage, setSelectedPackage] = useState("");

  return (
    <div className="min-h-screen bg-[#F8F7F4] text-[#14231B]" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <StatsStrip />
        <WhatWeDo />
        <Why />
        <HowItWorks />
        <SocialImpact />
        <Pricing onSelect={setSelectedPackage} />
        <About />
        <Faq />
        <BookingForm selectedPackage={selectedPackage} />
      </main>
      <Footer />
    </div>
  );
}
